import { Button } from "@mantine/core";
import { useLoaderStore } from "@modules/loader/useLoader.hook";
import { IconShoppingBag } from "@tabler/icons-react";
import type { ReactNode } from "react";

interface IAppBuyButtonProps {
  onClick: () => void;
  label: ReactNode;
}

const AppBuyButton: React.FC<IAppBuyButtonProps> = ({ onClick, label }) => {
  const loaderStore = useLoaderStore();

  return (
    <>
      <Button
        loading={loaderStore.isLoading()}
        classNames={{
          root: "bg-secret-blue-default disabled:grayscale text-primary-white hover:bg-secret-blue-light hover:text-primary-white border-none p-3 h-full",
        }}
        radius={12}
        rightSection={<IconShoppingBag />}
        variant="default"
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
      >
        {label}
      </Button>
    </>
  );
};

export default AppBuyButton;
